import {RootStore} from './RootStore';
import {action} from 'mobx';
import agent from '../api/agent';
import { StudentAttendanceParam,StudentAttendanceDetailParam,LecturerAttendanceParam,StudentAbsenceMaxParam } from "../models/Attendance";


class AttendanceStore{
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
      this.rootStore = rootStore; 
    }

    @action getStudentAttendanceList = async (param:StudentAttendanceParam) => {
        try 
        {   
            const list = await agent.StudentAttendance.studentAttendanceList(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action getStudentAttendanceListDetail = async (param:StudentAttendanceDetailParam) => {
        try 
        {   
            const list = await agent.StudentAttendance.StudentAttendanceListDetail(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action getCreatedDate= async (institution: string, strm: string) => {
        const list = this.getResponseCreatedDate(institution, strm);
        return list;
    };

    getResponseCreatedDate  = async (institution: string, strm: string)  => {
        const list = await agent.StudentAttendance.createdDate(institution, strm);
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };

    @action processUpdateCallStatus = async (param:any) => {
        try 
        {   
            const list = await agent.StudentAttendance.processUpdateCallStatus(param);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action getCallReason= async () => {
        const list = this.getResponseCallReason();
        return list;
    };

    getResponseCallReason  = async ()  => {
        const list = await agent.StudentAttendance.callReason();
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };

    @action getLecturerAttendanceList = async (param:LecturerAttendanceParam) => {
        try 
        {   
            const list = await agent.LecturerAttendance.lecturerAttendanceList(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action getStudentAbsenceMaxList = async (param:StudentAbsenceMaxParam) => {
        try 
        {   
            const list = await agent.StudentAttendance.studentAbsenceMaxList(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action getAbsenceType= async () => {
        const list = this.getResponseAbsenceType();
        return list;
    };

    getResponseAbsenceType  = async ()  => {
        const list = await agent.StudentAttendance.absenceType();
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };
}

export default AttendanceStore